module.exports = "<p>We are sorry, the requested page could not be found.</p>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/page-not-found/page-not-found.component.html
// module id = ./src/app/page-not-found/page-not-found.component.html
// module chunks = main